import axiosInstance from './axiosInstance';

// 匹配相关API
export const matchApi = {
  // 获取匹配列表
  getMatchList: async (params = {}) => {
    try {
      const response = await axiosInstance.get('match/records', { params });
      // 直接返回响应数据
      return response.data;
    } catch (error) {
      console.error('获取匹配列表失败:', error);
      throw new Error(error.response?.data?.message || '获取匹配列表失败');
    }
  },

  // 创建匹配记录
  createRecord: async (data) => {
    try {
      const response = await axiosInstance.post('match/records', data);
      return response.data;
    } catch (error) {
      console.error('创建匹配记录失败:', error);
      throw new Error(error.response?.data?.message || '创建匹配记录失败');
    }
  },

  // 更新匹配记录
  updateRecord: async (id, data) => {
    try {
      const response = await axiosInstance.put(`match/records/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('更新匹配记录失败:', error);
      throw new Error(error.response?.data?.message || '更新匹配记录失败');
    }
  },

  // 删除匹配记录
  deleteRecord: async (id) => {
    try {
      const response = await axiosInstance.delete(`match/records/${id}`);
      return response.data;
    } catch (error) {
      console.error('删除匹配记录失败:', error);
      throw new Error(error.response?.data?.message || '删除匹配记录失败');
    }
  },

  // 获取匹配记录详情
  getRecordDetail: async (id) => {
    try {
      const response = await axiosInstance.get(`match/records/${id}`);
      return response.data;
    } catch (error) {
      console.error('获取匹配记录详情失败:', error);
      throw new Error(error.response?.data?.message || '获取匹配记录详情失败');
    }
  },

  // 上传文件
  uploadFile: async (file, fileType) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('file_type', fileType);

      const response = await axiosInstance.post('match/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('上传文件失败:', error);
      throw new Error(error.response?.data?.message || '上传文件失败');
    }
  },

  // 开始匹配
  startMatch: async (id) => {
    try {
      const response = await axiosInstance.post(`match/records/${id}/start`);
      return response.data;
    } catch (error) {
      console.error('开始匹配失败:', error);
      throw new Error(error.response?.data?.message || '开始匹配失败');
    }
  },

  // 停止匹配
  stopMatch: async (id) => {
    try {
      const response = await axiosInstance.post(`match/records/${id}/stop`);
      return response.data;
    } catch (error) {
      console.error('停止匹配失败:', error);
      throw new Error(error.response?.data?.message || '停止匹配失败');
    }
  },

  // 重试匹配
  retryMatch: async (id) => {
    try {
      const response = await axiosInstance.post(`match/records/${id}/retry`);
      return response.data;
    } catch (error) {
      console.error('重试匹配失败:', error);
      throw new Error(error.response?.data?.message || '重试匹配失败');
    }
  },

  // 获取匹配进度
  getMatchProgress: async (id) => {
    try {
      const response = await axiosInstance.get(`match/records/${id}/progress`);
      return response.data;
    } catch (error) {
      console.error('获取匹配进度失败:', error);
      throw new Error(error.response?.data?.message || '获取匹配进度失败');
    }
  },

  // 获取匹配结果
  getMatchResult: async (id) => {
    try {
      const response = await axiosInstance.get(`match/records/${id}/result`);
      return response.data;
    } catch (error) {
      console.error('获取匹配结果失败:', error);
      throw new Error(error.response?.data?.message || '获取匹配结果失败');
    }
  }
}; 